import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { Add, PersonAdd } from "@mui/icons-material";
import MDButton from "components/MDButton";
import { useAuthContext } from "hooks/useAuthContext";
import { API_URL } from "../../../../config";
import { toast } from "sonner";
import MDBox from "../../../../components/MDBox";
import DataTable from "../../../../examples/Tables/DataTable";

const ChooseHomepageProjectsPopup = ({ fetchHomepageProjects }) => {
  const { user } = useAuthContext();
  const [open, setOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);

  const columns = [
    { Header: "Title", accessor: "title", width: "80%" },
    { Header: "add", accessor: "add", align: "center" },
  ];

  const handleClickOpen = () => {
    setOpen(true);
    fetchSuggestedProjects();
  };

  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const fetchSuggestedProjects = async () => {
    try {
      const response = await fetch(`${API_URL}/projects/completed`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });

      const fetchedProjects = await response.json();

      if (response.ok) {
        setProjects(fetchedProjects);
      } else {
        toast.error("Error", { description: "Error fetching projects" });
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    const rows = projects.map((project) => ({
      title: project.projectTitle,
      add: (
        <MDButton
          variant="contained"
          color="info"
          size="small"
          sx={{
            minWidth: 40, // Diameter of the button
            width: 40,
            height: 40,
            padding: 0, // Ensures the button remains circular
            borderRadius: "50%", // Makes the button circular
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => handleAddToHomepage(project.id)}
        >
          <Add />
        </MDButton>
      ),
    }));
    setRows(rows);
  }, [projects]);

  const handleAddToHomepage = async (projectId) => {
    try {
      const response = await fetch(
        `${API_URL}/projects/addtohomepage/${projectId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify({ is_chosen: true }),
        }
      );

      if (response.ok) {
        toast.success("Success", {
          description: "Project added to homepage",
        });
        await fetchSuggestedProjects();
        await fetchHomepageProjects();
      } else {
        toast.error("Error", {
          description: "Error adding project to homepage",
        });
      }
    } catch (error) {
      toast.error("Error", { description: "Error adding project to homepage" });
    }
  };

  const filteredProjects = projects.filter((project) =>
    project.projectTitle.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <MDButton
        variant="contained"
        color="info"
        size="small"
        startIcon={<PersonAdd />}
        onClick={handleClickOpen}
      >
        Add homepage project
      </MDButton>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: { padding: 20, borderRadius: 10 },
        }}
      >
        <DialogTitle>Add homepage project</DialogTitle>
        <MDBox pt={2}>
          <DataTable
            table={{ columns, rows }}
            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={true}
            noEndBorder
            canSearch={true}
          />
        </MDBox>
        <DialogActions>
          <MDButton onClick={handleClose} color="primary">
            Close
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ChooseHomepageProjectsPopup;
